import React, { useEffect, useState } from "react";
import { Button, Nav, Navbar } from "react-bootstrap";
import TelegramIcon from "../assets/images/telegramIcon.svg";
import WhatsappIcon from "../assets/images/whatsappIconnew.png";
import { getNotifications } from "../redux/app/actions";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuIcon from "../assets/images/menu-icon.svg";
import MobLeftbar from "./MobLeftbar";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { APP_CONST } from "../config/const";
import { isMobile } from "react-device-detect";
import BottomHead from "./BottomHead";
import ModalWrapper from "./ModalWrapper";
import { AiOutlineClose } from "react-icons/ai";

const Header = ({ agentCode = "" }) => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const [showLeftBar, setShowLeftBar] = useState(false);
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState(APP_CONST.AUTH_MODAL.LOGIN);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    if (showLeftBar) {
      htmlElement.style.overflow = "hidden";
    } else {
      htmlElement.style.overflow = "auto";
    }
  }, [showLeftBar]);

  useEffect(() => {
    if (agentCode) {
      setShowAuthModals(true);
      setDefaultModal(APP_CONST.AUTH_MODAL.MOBILE_NUMBER);
    }
  }, [agentCode]);

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };

  const htmlElement = document.documentElement;

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };
  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header header_bfrlgn">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <Button
                  variant="primary menu-btn"
                  onClick={() => setShowLeftBar((p) => !p)}
                  className="d-block d-md-none"
                >
                  <img src={MenuIcon} alt="User Menu Icon" width={25} />
                </Button>
                <div className="logo">
                  <a href="/">
                    <img src={appDetails?.LOGO_URL} alt="Logo" />
                    {/* <img src={logo} alt="Logo" /> */}
                  </a>
                </div>
                <div className="header-left ms-xl-4 d-none d-lg-block">
                  <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="d-none"
                  />
                  <Navbar.Collapse id="basic-navbar-nav" className="d-block">
                    <Nav className="me-auto">
                      <div
                        onClick={() => {
                          navigate("/sports/jetfair?section=inplay");
                        }}
                        className="nav-link"
                      >
                        Exchange
                      </div>

                      <div
                        onClick={() => {
                          navigate("/atlas-lobby");
                        }}
                        className="nav-link"
                      >
                        Sportsbook
                      </div>

                      <div
                        onClick={() => {
                          navigate("/allCasino");
                        }}
                        className="nav-link"
                      >
                        Live Dealers
                      </div>

                      <div
                        onClick={() => {
                          navigate("/casino/spribe/aviator");
                        }}
                        className="nav-link"
                      >
                        Aviator
                      </div>
                    </Nav>
                  </Navbar.Collapse>
                </div>
                <div className="headerRight ms-auto">
                  <ul className="d-none">
                    <li className="">
                      <a
                        className="tg"
                        href={
                          appDetails?.TELEGRAM != ""
                            ? appDetails?.TELEGRAM
                            : "#"
                        }
                        target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                      >
                        <img src={TelegramIcon} alt="Telegram Icon" />
                      </a>
                    </li>
                    <li>
                      <a
                        className="wtp"
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "#"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsappIcon} alt="Whatsapp Icon" />
                      </a>
                    </li>
                  </ul>

                  <Button
                    variant="primary"
                    onClick={() => {
                      isMobile
                        ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                        : navigate("/sign-in");
                    }}
                    className="login_btn me-2"
                  >
                    Log In
                  </Button>

                  <Button
                    variant="primary"
                    onClick={() => {
                      isMobile
                        ? handleModalShow(APP_CONST.AUTH_MODAL.MOBILE_NUMBER)
                        : navigate("/mobile-number");
                    }}
                    className="signup_btn"
                  >
                    Sign Up
                  </Button>
                  <ul className="" style={{ marginLeft: "5px" }}>
                    <li>
                      <GamesSearchModal />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
            agentCode={agentCode}
          />
        )}
        {showLeftBar && (
          <MobLeftbar
            className="d-block d-md-none"
            setShowAuthModals={setShowAuthModals}
          />
        )}
      </header>
      <BottomHead />
    </>
  );
};

export default Header;
